export const phoneCheck = (phone) => {
  var re = /([^0-9])/g
  phone = phone.replace(re, '')
  if (phone.substring(0,2) !== '+1') {
    phone = '+1' + phone
  }
  return phone
}